<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">IPV</h4>
            </div>
            <div class="card-body">
                <h3 class="card-title">Datos de la pregunta</h3>
                <hr>
                <div class="row m-t-20">
                    <div class="col-12 ">
                        <h4 class="card-title">Tipos</h4>
                        <div class="demo-checkbox">
                            <div class="row">

                                <div class="col-xs-6 col-md-2">
                                    <input [(ngModel)]="typeArray[0]" type="checkbox" ng-mo id="basic_checkbox_1"  />
                                    <label for="basic_checkbox_1">DGV</label>
                                </div>
                                <div class="col-xs-6  col-md-2">
                                    <input [(ngModel)]="typeArray[1]" type="checkbox" id="basic_checkbox_2"  />
                                    <label  for="basic_checkbox_2">I</label>
                                </div>
                                <div class="col-xs-6  col-md-2">
                                    <input [(ngModel)]="typeArray[2]" type="checkbox" id="basic_checkbox_3"  />
                                    <label  for="basic_checkbox_3">II</label>
                                </div>
                                <div class="col-xs-6  col-md-2">
                                    <input [(ngModel)]="typeArray[3]" type="checkbox" id="basic_checkbox_4"  />
                                    <label  for="basic_checkbox_4">III</label>
                                </div>
                                <div class="col-xs-6  col-md-2">
                                    <input [(ngModel)]="typeArray[4]" type="checkbox" id="basic_checkbox_5"  />
                                    <label  for="basic_checkbox_5">IV</label>
                                </div>
                                <div class="col-xs-6  col-md-2">
                                    <input [(ngModel)]="typeArray[5]" type="checkbox" id="basic_checkbox_6"  />
                                    <label  for="basic_checkbox_6">V</label>
                                </div>
                                <div class="col-xs-6 col-md-2">
                                    <input [(ngModel)]="typeArray[6]" type="checkbox" id="basic_checkbox_7"  />
                                    <label  for="basic_checkbox_7">VI</label>
                                </div>
                                <div class="col-xs-6 col-md-2">
                                    <input [(ngModel)]="typeArray[7]" type="checkbox" id="basic_checkbox_8"  />
                                    <label  for="basic_checkbox_8">VII</label>
                                </div>
                                <div class="col-xs-6 col-md-2">
                                    <input  [(ngModel)]="typeArray[8]" type="checkbox" id="basic_checkbox_9"  />
                                    <label  for="basic_checkbox_9">VIII</label>
                                </div>
                                <div class="col-xs-6 col-md-2">
                                    <input [(ngModel)]="typeArray[9]" type="checkbox" id="basic_checkbox_10"  />
                                    <label  for="basic_checkbox_10">IX</label>
                                </div>
     
                            </div>
                        </div>
                    </div>
                </div>
                <form [formGroup]="ipvForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <div class="row p-t-20">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="row" formGroupName="opcA">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción A</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje opción A</label>
                                        <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción A">
                                    </div>
                                </div>
                            </div>

                            <div class="row" formGroupName="opcB">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción B</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje opción B</label>
                                        <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción B">
                                    </div>
                                </div>
                            </div>

                            <div class="row" formGroupName="opcC">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="control-label">Texto opción C</label>
                                        <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                    </div>
                                </div>
                                <div class="col-md-6">    
                                    <div class="form-group">
                                        <label class="control-label">Puntaje opción C</label>
                                        <input formControlName="value" type="number" class="form-control" placeholder="Puntaje opción C">
                                    </div>
                                </div>
                            </div>

                        </div>

                        
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn btn-success"> <i class="fa fa-check"></i> Guardar</button>
                        <button type="button" class="btn btn-inverse" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>